import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.set";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classStaticPrivateFieldSpecGet(receiver, classConstructor, descriptor) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

import axios from 'axios';
import { getServicesBasicAuth, getDMSBasicAuth, getJWT, withJWT, withBasicAuth, getAdditionalHeaders } from '../../setup';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
var CancelToken = axios.CancelToken;
export var SERVICES = 'SERVICES';
export var DMS = 'DMS';
var defaultOptions = {
  type: SERVICES
};

var getBasicAuthByType = function getBasicAuthByType(type) {
  if (type === DMS) {
    return getDMSBasicAuth();
  }

  return getServicesBasicAuth();
};

export var queue = new Set();
/**
 * Service for handling all requests.
 */

var Service =
/*#__PURE__*/
function () {
  function Service() {
    _classCallCheck(this, Service);
  }

  _createClass(Service, [{
    key: "test",
    value: function test() {
      return this;
    }
  }], [{
    key: "cancelAll",

    /** @method
     * @name cancelAll
     *  @param {string=} method - Method for cancel all requests or cancel by get or post method.
     */
    value: function cancelAll(method) {
      if (method) {
        queue.forEach(function (value) {
          if (value.method === method) {
            value.cancel();
          }
        });
      } else {
        queue.forEach(function (value) {
          value.cancel();
        });
      }
    }
    /** @method
     * @name isCanceled
     * Method for check error type.
     @param {Error} thrown - The title of the book.
     */

  }, {
    key: "generalHeaders",

    /** @method
     * @name generalHeaders
     */
    value: function generalHeaders(type) {
      var Authorization = withBasicAuth() ? getBasicAuthByType(type) : undefined;

      if (Authorization === undefined) {
        return {
          'Content-Type': 'application/json'
        };
      }

      return {
        'Content-Type': 'application/json',
        Authorization: Authorization
      };
    }
    /** @method
     * @name jwtToken
     */

  }, {
    key: "secureSetup",

    /** @method
     * @name secureSetup
     */
    value: function secureSetup(isSecure, type) {
      var axiosSetup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var axiosSetupHeaders = axiosSetup.headers || {};
      return withJWT() ? _objectSpread({}, Service.generalSettings, {}, axiosSetup, {
        headers: _objectSpread({}, Service.generalHeaders(type), {}, getAdditionalHeaders(), {}, isSecure === true ? Service.jwtToken : {}, {}, axiosSetupHeaders)
      }) : _objectSpread({}, Service.generalSettings, {}, axiosSetup, {
        headers: _objectSpread({}, getAdditionalHeaders(), {}, axiosSetupHeaders)
      });
    }
  }, {
    key: "getRequest",

    /** @method
     * @name getRequest
     * wrapper for axios get request.
     *  @param {string} url - url.
     *  @param {object=} setup - setting for request.
     *  @param {boolean=} setup.isSecure - isSecure request.
     *  @param {string=} setup.type - type request.
     *  @param {object=} setup.axiosSetup - another axios settings.
     *  @param {boolean=} setup.isAutoCancel - isAutoCancel request.
     *  @param {boolean=} setup.withCancel - with canceling request.
     */
    value: function getRequest(url) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions,
          isSecure = _ref.isSecure,
          type = _ref.type,
          axiosSetup = _ref.axiosSetup,
          _ref$isAutoCancel = _ref.isAutoCancel,
          isAutoCancel = _ref$isAutoCancel === void 0 ? false : _ref$isAutoCancel,
          _ref$withCancel = _ref.withCancel,
          withCancel = _ref$withCancel === void 0 ? false : _ref$withCancel;

      var source = CancelToken.source();
      var axiosRequest = axios.get(url, Service.secureSetup(isSecure, type, _objectSpread({}, axiosSetup, {
        cancelToken: source.token
      })));

      _classStaticPrivateFieldSpecGet(Service, Service, _autoCancel).call(Service, isAutoCancel, url, source.cancel);

      source.method = 'get';

      _classStaticPrivateFieldSpecGet(Service, Service, _addQueue).call(Service, source);

      var axiosRequestWrapper = new Promise(
      /*#__PURE__*/
      function () {
        var _ref2 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee(resolve, reject) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.t0 = resolve;
                  _context.next = 4;
                  return axiosRequest;

                case 4:
                  _context.t1 = _context.sent;
                  (0, _context.t0)(_context.t1);
                  delete Service.autoCancelQueue[url];
                  _context.next = 12;
                  break;

                case 9:
                  _context.prev = 9;
                  _context.t2 = _context["catch"](0);
                  reject(_context.t2);

                case 12:
                  _context.prev = 12;
                  Service.cancelRequest(source);
                  return _context.finish(12);

                case 15:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[0, 9, 12, 15]]);
        }));

        return function (_x, _x2) {
          return _ref2.apply(this, arguments);
        };
      }());

      if (withCancel) {
        return [axiosRequestWrapper, function () {
          return Service.cancelRequest(source);
        }];
      }

      return axiosRequestWrapper;
    }
    /** @method
     * @name postRequest
     * wrapper for axios post request.
     *  @param {string} url - url.
     *  @param {object} data - data.
     *  @param {object=} setup - setting for request.
     *  @param {boolean=} setup.isSecure - isSecure request.
     *  @param {string=} setup.type - type request.
     *  @param {object=} setup.axiosSetup - another axios settings.
     *  @param {boolean=} setup.isAutoCancel - isAutoCancel request.
     *  @param {boolean=} setup.withCancel - with canceling request.
     */

  }, {
    key: "postRequest",
    value: function postRequest(url, data) {
      var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions,
          isSecure = _ref3.isSecure,
          type = _ref3.type,
          axiosSetup = _ref3.axiosSetup,
          _ref3$isAutoCancel = _ref3.isAutoCancel,
          isAutoCancel = _ref3$isAutoCancel === void 0 ? false : _ref3$isAutoCancel,
          _ref3$withCancel = _ref3.withCancel,
          withCancel = _ref3$withCancel === void 0 ? false : _ref3$withCancel;

      var source = CancelToken.source();

      _classStaticPrivateFieldSpecGet(Service, Service, _addQueue).call(Service, source);

      var axiosRequest = axios.post(url, data, Service.secureSetup(isSecure, type, _objectSpread({}, axiosSetup, {
        cancelToken: source.token
      })));

      _classStaticPrivateFieldSpecGet(Service, Service, _autoCancel).call(Service, isAutoCancel, url, source.cancel);

      source.method = 'post';

      _classStaticPrivateFieldSpecGet(Service, Service, _addQueue).call(Service, source);

      var axiosRequestWrapper = new Promise(
      /*#__PURE__*/
      function () {
        var _ref4 = _asyncToGenerator(
        /*#__PURE__*/
        regeneratorRuntime.mark(function _callee2(resolve, reject) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.prev = 0;
                  _context2.t0 = resolve;
                  _context2.next = 4;
                  return axiosRequest;

                case 4:
                  _context2.t1 = _context2.sent;
                  (0, _context2.t0)(_context2.t1);
                  delete Service.autoCancelQueue[url];
                  _context2.next = 12;
                  break;

                case 9:
                  _context2.prev = 9;
                  _context2.t2 = _context2["catch"](0);
                  reject(_context2.t2);

                case 12:
                  _context2.prev = 12;
                  Service.cancelRequest(source);
                  return _context2.finish(12);

                case 15:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, null, [[0, 9, 12, 15]]);
        }));

        return function (_x3, _x4) {
          return _ref4.apply(this, arguments);
        };
      }());

      if (withCancel) {
        return [axiosRequestWrapper, function () {
          return Service.cancelRequest(source);
        }];
      }

      return axiosRequestWrapper;
    }
    /** @method
     * @name putRequest
     * wrapper for axios put request.
     *  @param {string} url - url.
     *  @param {object} data - data.
     *  @param {object=} setup - setting for request.
     *  @param {boolean=} setup.isSecure - isSecure request.
     *  @param {string=} setup.type - type request.
     *  @param {object=} setup.axiosSetup - another axios settings.
     */

  }, {
    key: "putRequest",
    value: function putRequest(url, data) {
      var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions,
          isSecure = _ref5.isSecure,
          type = _ref5.type,
          axiosSetup = _ref5.axiosSetup;

      return axios.put(url, data, Service.secureSetup(isSecure, type, axiosSetup));
    }
    /** @method
     * @name patchRequest
     *  wrapper for axios patch request
     *  @param {string} url - url.
     *  @param {object} data - data.
     *  @param {object=} setup - setting for request.
     *  @param {boolean=} setup.isSecure - isSecure request.
     *  @param {string=} setup.type - type request.
     *  @param {object=} setup.axiosSetup - another axios settings.
     */

  }, {
    key: "patchRequest",
    value: function patchRequest(url, data) {
      var _ref6 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions,
          isSecure = _ref6.isSecure,
          type = _ref6.type,
          axiosSetup = _ref6.axiosSetup;

      return axios.patch(url, data, Service.secureSetup(isSecure, type, axiosSetup));
    }
    /** @method
     * @name deleteRequest
     *  wrapper for axios delete request
     *  @param {string} url - url.
     *  @param {object=} setup - setting for request.
     *  @param {boolean=} setup.isSecure - isSecure request.
     *  @param {string=} setup.type - type request.
     *  @param {object=} setup.axiosSetup - another axios settings.
     */

  }, {
    key: "deleteRequest",
    value: function deleteRequest(url) {
      var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions,
          isSecure = _ref7.isSecure,
          type = _ref7.type,
          axiosSetup = _ref7.axiosSetup;

      return axios.delete(url, Service.secureSetup(isSecure, type, axiosSetup));
    }
  }, {
    key: "jwtToken",
    get: function get() {
      var jwt = getJWT();

      if (jwt === undefined) {
        return {};
      }

      return {
        'X-Token-Jwt': getJWT()
      };
    }
    /** @method
     * @name generalSettings
     */

  }, {
    key: "generalSettings",
    get: function get() {
      return {};
    }
  }]);

  return Service;
}();

_defineProperty(Service, "autoCancelQueue", {});

var _autoCancel = {
  writable: true,
  value: function value(isAutoCancel, url, cancelToken) {
    if (isAutoCancel) {
      if (typeof Service.autoCancelQueue[url] === 'function') {
        Service.autoCancelQueue[url]();
        delete Service.autoCancelQueue[url];
      }

      Service.autoCancelQueue[url] = cancelToken;
    }
  }
};

_defineProperty(Service, "isCanceled", function (thrown) {
  return axios.isCancel(thrown);
});

_defineProperty(Service, "cancelRequest", function (source) {
  source.cancel();
  queue.delete(source);
});

var _addQueue = {
  writable: true,
  value: function value(source) {
    queue.add(source);
  }
};
export default Service;